import React from 'react';
import { Grid, Header, Icon, Popup, Segment, Tab, Table, Transition } from 'semantic-ui-react';
import { IconHeader } from '../Professor/ProfessorInputGrades/css';
import SimpleTwoColumnTableRow from '../StudentPersonalInfo/SimpleTwoColumnTableRow';
import moment from 'moment';

export default class StudentInfoEmploymentServiceCS extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            student: JSON.parse(localStorage.getItem('student')),

        };
    }

    render() {
        return (
            <div >
                <h1>Informacije o studentu</h1>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            {this.state.student.firstName} {this.state.student.lastName} - {this.state.student.index}
                            <Header floated="right" style={IconHeader}>
                                <Popup
                                    floatd="right"
                                    trigger={<Icon link circular basic floated="right" name="arrow left" onClick={() => window.history.go(-1)} />}
                                    content="Nazad"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            <Header.Subheader>
                                Student/ica - index
                            </Header.Subheader>
                        </Header>
                    </Segment>


                    <Segment textAlign="center" verticalAlign="middle">
                        <Header textAlign="left"> <Header.Subheader as="h6" color="grey" textAlign="left">*Izmjena podataka upisa u semestar/apsolventski staž je moguća u svakom trenutku, kao i brisanje upisa u semestar/aspolventski staž.</Header.Subheader></Header>
                        <Table celled size="small" unstackable compact>
                            <Table.Header>
                                <Table.Row>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>

                                <SimpleTwoColumnTableRow
                                    name="JMBG"
                                    keyName="jmbg"
                                    value={this.state.student.jmbg}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Ime"
                                    keyName="firstName"
                                    value={this.state.student.firstName}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Prezime"
                                    keyName="lastName"
                                    value={this.state.student.lastName}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Ime oca"
                                    keyName="fatherName"
                                    value={this.state.student.fatherName}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Datum rođenja"
                                    keyName="dateOfBirth"
                                    value={this.state.student.dateOfBirth ? moment(this.state.student.dateOfBirth).format('D. M. YYYY.') : ''}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Organizaciona jedinica"
                                    keyName="organizationalUnit"
                                    value={this.state.student.organizationalUnitName}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Odsjek"
                                    keyName="department"
                                    value={this.state.student.departments[0].name}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Studijski program"
                                    keyName="studyProgramBasicName"
                                    value={this.state.student.studyProgramBasicName}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Ciklus studija"
                                    keyName="studyCycleName"
                                    value={this.state.student.studyCycleName}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Akademska godina"
                                    keyName="academicYear"
                                    value={this.state.student.academicYearName}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Semestar"
                                    keyName="studyProgramSemesterName"
                                    value={this.state.student.studyProgramSemesterName}
                                />
                                { (this.state.student.studyProgramSemesterName === 'Apsolventski staž') ? <SimpleTwoColumnTableRow
                                    name="Tip studiranja"
                                    keyName="gradAcademicYearStudyTypeName"
                                    value={this.state.student.gradAcademicYearStudyTypeName}
                                /> : <SimpleTwoColumnTableRow
                                    name="Tip studiranja"
                                    keyName="studyTypeName"
                                    value={this.state.student.studyTypeName}
                                />}
                                <SimpleTwoColumnTableRow
                                    name="Datum ispisa"
                                    keyName="dateOfAbandoment"
                                    value={this.state.student.dateOfAbandonment ? moment(this.state.student.dateOfAbandonment).format('D. M. YYYY.') : ''}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Datum diplomiranja"
                                    keyName="graduationDate"
                                    value={this.state.student.graduationDate ? moment(this.state.student.graduationDate).format('D. M. YYYY.') : ''}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Datum zadnje izmjene upisa u semestar/aposlventski staž"
                                    keyName="lastUpdated"
                                    value={this.state.student.sspsLastUpdated ? moment(this.state.student.sspsLastUpdated).format('D. M. YYYY.') : ''}
                                />
                            </Table.Body>
                        </Table>
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/EmploymentServiceCS/StudentInfoEmploymentServiceCS.js